import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { H5, Small } from '@upsolve/ui';

import ImageInContext from '../Media/ImageInContext';
import MockLaptop from './MockLaptop';

const LaptopDemoVideo = () => {
  const { prepVideoThumbnail } = useStaticQuery(graphql`
    query LaptopDemoVideoQuery {
      prepVideoThumbnail: file(base: { eq: "prep-video-thumbnail.png" }) {
        childImageSharp {
          fluid(cropFocus: CENTER, maxHeight: 540, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  return (
    <MockLaptop>
      <H5 as="span">Prep for Creditors Meeting</H5>
      <div className="video-previewer">
        <ImageInContext alt="Upsolve 341 meeting prep video" fluid={prepVideoThumbnail.childImageSharp.fluid} />
      </div>
      <Small><i>Also known as 341 Meeting</i></Small>
    </MockLaptop>
  );
}

export default LaptopDemoVideo;
